/* eslint-disable react/require-default-props */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Logger } from '@saviynt/common';
import { Box, Icon, Typography } from '@saviynt/design-system';

import { CF_CRT_MED, testIds } from '../../constants';

import './SafeBoundary.css';

interface SafeBoundaryProps extends React.PropsWithChildren {
  onError?: () => void;
}

interface SafeBoundaryState {
  isError: boolean;
}

class SafeBoundary extends React.Component<
  SafeBoundaryProps,
  SafeBoundaryState
> {
  constructor(props: SafeBoundaryProps) {
    super(props);
    this.state = { isError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    Logger.log('Error rendering forms: ', error, errorInfo);
    this.setState({ isError: true });

    const { onError } = this.props;

    if (onError) {
      onError();
    }
  }

  render(): React.ReactNode {
    const { isError } = this.state;
    const { children } = this.props;

    if (isError) {
      return (
        <Box
          tag='div'
          className='SafeBoundary-wrapper'
          dataTestId={testIds.GEN_SAFE_BOUNDARY_ERROR}>
          <Icon kind='StopProcess' size='large' color={CF_CRT_MED} />
          <Typography kind='body2' color={CF_CRT_MED}>
            <FormattedMessage
              id='apz7lc'
              defaultMessage='System encountered an error. Please contact the Support Administrator'
              description='System encountered an error. Please contact the Support Administrator'
            />
          </Typography>
        </Box>
      );
    }

    return children;
  }
}

export default SafeBoundary;
